<template>
    <div>
        <el-dialog title="分析字段设置" :visible="true" width="1100px" v-if="isShowSetting" @close="$emit('close')" append-to-body  :close-on-click-modal="false">
            <div v-loading="loading">
                <div class="fieldSetting-tip">
                   <span style="color: #FF5779;text-align: center;">*</span>
                   <span>分析字段：</span>
                </div>
                <el-checkbox-group v-model="selectList" class="fieldSetting-parent new-input-box" @change="handleSelect">
                    <!-- <el-checkbox class="fieldSetting-children" v-for="item in settingList" :label="item.prop" :key="item.prop" :disabled="item.prop=='activityTitle'">{{ item.label }}</el-checkbox> -->
                    <div class="fieldSetting-item">
                        <el-checkbox class="fieldSetting-children" v-for="item in setting1" :label="item.prop" :key="item.prop" :disabled="item.prop=='activityTitle'">{{ item.label }}</el-checkbox>
                    </div>
                    <div class="fieldSetting-item">
                        <el-checkbox class="fieldSetting-children" v-for="item in setting2" :label="item.prop" :key="item.prop">{{ item.label }}</el-checkbox>
                    </div>
                    <div class="fieldSetting-item">
                        <el-checkbox class="fieldSetting-children" v-for="item in setting3" :label="item.prop" :key="item.prop">{{ item.label }}</el-checkbox>
                    </div>
                    <div class="fieldSetting-item">
                        <el-checkbox class="fieldSetting-children" v-for="item in setting4" :label="item.prop" :key="item.prop">{{ item.label }}</el-checkbox>
                    </div>
                    <div class="fieldSetting-item">
                        <el-checkbox class="fieldSetting-children" v-for="item in setting5" :label="item.prop" :key="item.prop">{{ item.label }}</el-checkbox>
                    </div>
                    <div class="fieldSetting-item">
                        <el-checkbox class="fieldSetting-children" v-for="item in setting6" :label="item.prop" :key="item.prop">{{ item.label }}</el-checkbox>
                    </div>
                </el-checkbox-group>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button style="margin-right: 8px;" @click="close">取消</el-button>
                <el-button type="primary" @click="sureBtn()">保存</el-button>
            </div>
      </el-dialog>
    </div>
    </template>
    
    <script>
    import {fieldJsonConfigSave,fieldJsonConfig} from "@/api/smsMarketing"
    export default {
    name: '' ,
    components: {},
    props:{
        isShowSetting: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading:false,
            selectList: ['sellerNick','activityTitle','content','sendTime','roi','sendNum','pv','uv','clickRate','orderRate','ordPins','ordAmount','ordNum','ordQtty','orderPayRate','payRate','payPins','payAmount','payNum','payQtty','perCustomerTransaction','cartNum'],
            setting1: [
                {
                    prop: "sellerNick",
                    label: "店铺名称",
                },
                {
                    prop: 'activityTitle',
                    label: "活动主题",
                },
                {
                    prop: 'content',
                    label: "短信内容",
                },
                {
                    prop: 'sendTime',
                    label: "发送时间",
                },
                {
                    prop: 'roi',
                    label: "ROI（投入产出比）",
                },
                {
                    prop: 'marketingCosts',
                    label: "营销成本",
                },
                {
                    prop: 'sendSubmitNum',
                    label: "预计触达人数",
                },
                {
                    prop: 'sendNum',
                    label: "实际触达人数",
                },
                {
                    prop: 'rate',
                    label: "触达率",
                },
            ],
            setting2: [
                {
                    prop: 'pv',
                    label: "短链点击PV",
                },
                {
                    prop: 'uv',
                    label: "短链点击UV",
                },
                {
                    prop: 'clickRate',
                    label: "短链点击率（%）",
                },
                {
                    prop: 'skuPvNum',
                    label: "商品详情页PV",
                },
                {
                    prop: 'skuUvNum',
                    label: "商品详情页UV",
                },
                {
                    prop: 'shopPvNum',
                    label: "店铺首页PV",
                },
                {
                    prop: 'shopUvNum',
                    label: "店铺首页UV",
                },
            ],
            setting3: [
                {
                    prop: 'orderRate',
                    label: "下单转化率（%）",
                },
                {
                    prop: 'ordPins',
                    label: "下单人数",
                },
                {
                    prop: 'ordAmount',
                    label: "下单金额",
                },
                {
                    prop: 'ordNum',
                    label: "下单订单数",
                },
                {
                    prop: 'ordQtty',
                    label: "下单件数",
                },
            ],
            setting4: [
                {
                    prop: 'orderPayRate',
                    label: "下单-付款转化率（%）",
                },
                {
                    prop: 'payRate',
                    label: "付款转化率（%）",
                },
                {
                    prop: 'payPins',
                    label: "付款人数",
                },
                {
                    prop: 'payAmount',
                    label: "付款金额",
                },
                {
                    prop: 'payNum',
                    label: "付款订单数",
                },
                {
                    prop: 'payQtty',
                    label: "付款件数",
                },
                {
                    prop: 'perCustomerTransaction',
                    label: "客单价",
                },
            ],
            setting5: [
                {
                    prop: 'followSkuNum',
                    label: "关注商品人数",
                },
                {
                    prop: 'followShopNum',
                    label: "关注店铺人数",
                },
                {
                    prop: 'cartNum',
                    label: "加购人数",
                },
            ],
            setting6: [
                {
                    prop: 'memberBuyPins',
                    label: "已购会员购买客户数",
                },
                {
                    prop: 'brandMemberBuyPins',
                    label: "品牌开卡会员购买客户数",
                },
                {
                    prop: 'cardMemberBuyPins',
                    label: "店铺开卡会员购买客户数",
                },
                {
                    prop: 'brandMemberNewBuyPins',
                    label: "品牌开卡会员购买新客户数",
                },
                {
                    prop: 'cardMemberNewBuyPins',
                    label: "店铺开卡会员购买新用户数",
                },
            ],
            settingList: [],
            copyList: []
        }
    },
    computed: {},
    created() {
       this.copyList = JSON.parse(JSON.stringify(this.selectList))
    },
    mounted() {
       this.fieldJsonConfigQuery()
    },
    methods: {
        // 已保存的项
        async fieldJsonConfigQuery() {
            this.selectList = []
            try {
                this.loading = true
                const res = await fieldJsonConfig({type:1})
                if(res.code==1) {
                    this.loading = false
                    if(res.data && res.data.fieldJson) {
                        const data = JSON.parse(res.data.fieldJson)
                        data.forEach((item)=>{
                            this.selectList.push(item.prop)
                        })
                    } else {
                        this.selectList = [...this.copyList]
                    }

                }
            } catch (error) {
                this.loading = false
            }
        },
        async sureBtn(){
            let params = []
            this.settingList = [...this.setting1,...this.setting2,...this.setting3,...this.setting4,...this.setting5,...this.setting6]
            this.settingList.forEach((item)=>{
                this.selectList.forEach((child=>{
                    if(item.prop==child) {
                        params.push(item)
                    }
                }))
            })
            try {
                this.loading = true
                const res = await fieldJsonConfigSave({fieldJson: JSON.stringify(params),type: 1})
                if(res.code==1) {
                    this.loading = false
                    this.$message.success("字段设置成功")
                    this.$emit("reData")
                }
            } catch (error) {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        }
    }
    }
    </script>
    <style lang='scss' scoped>
    /deep/ .el-dialog__body{
        height: 408px !important;
    }
    .fieldSetting-tip {
        display: flex;
        align-items: center;
    }
    .fieldSetting-parent {
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        .fieldSetting-item {
            display: flex;
            flex-direction: column;
            .fieldSetting-children {
                margin-top: 20px;
                font-size: 14px;
                /deep/.el-checkbox__inner {
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                }
            }  
        }
    }
    </style>